module.exports = __webpack_public_path__ + "img/NZAvsPTF.b17fcd67.png";